import {connect} from 'react-redux';
import PopupMessage from './PopupMessage';
import {hideLittlePopup} from '../../actions/step9LittlePopup';

const mapStateToProps = ({
                           step9LittlePopup: {display, message}
                         }) => ({
  display,
  message
});

export default connect(
  mapStateToProps,
  {hideLittlePopup}
)(PopupMessage);
